import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, Scale, ArrowLeft, CreditCard } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { createCheckoutSession } from '../lib/api';
import { useState } from 'react';
import { toast } from 'sonner';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleRetryPayment = async () => {
    if (!user) {
      navigate('/register');
      return;
    }

    setLoading(true);
    try {
      const res = await createCheckoutSession(window.location.origin);
      if (res.data.checkout_url) {
        window.location.href = res.data.checkout_url;
      }
    } catch (err) {
      toast.error('Failed to create checkout session');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="payment-cancel-page">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-md bg-navy flex items-center justify-center">
              <Scale className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading text-xl font-bold tracking-tight text-foreground">Legal AIDynamics</span>
          </div>
          <XCircle className="w-16 h-16 mx-auto text-muted-foreground mb-4" />
          <CardTitle className="font-heading text-2xl">Payment Cancelled</CardTitle>
          <CardDescription className="font-body">
            Your subscription setup was not completed.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground font-body text-center">
            A subscription is required to use Legal AIDynamics. You can complete your subscription now or come back later.
          </p>
          
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <h4 className="font-medium text-sm">Subscription includes:</h4>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Unlimited document uploads</li>
              <li>• AI-powered exhibit identification</li>
              <li>• Custom exhibit labeling</li>
              <li>• Case collaboration features</li>
              <li>• Court-ready PDF reports</li>
            </ul>
            <p className="text-sm font-semibold text-bronze pt-2">$20/month</p>
          </div>

          <Button 
            onClick={handleRetryPayment} 
            disabled={loading}
            className="w-full bg-bronze hover:bg-bronze-light"
            data-testid="retry-payment-btn"
          >
            {loading ? (
              <span className="flex items-center gap-2">Processing...</span>
            ) : (
              <span className="flex items-center gap-2">
                <CreditCard className="w-4 h-4" />
                Complete Subscription
              </span>
            )}
          </Button>
          
          <Button 
            variant="outline" 
            onClick={handleLogout}
            className="w-full"
            data-testid="back-to-login-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
